import React from 'react';
import PropTypes from 'prop-types';
import './PsDocumentSchemasTd.css';

export const PsDocumentSchemasTd = (
    {
        schemas,
    },
) => {
    return (
        <div className="ps-document-schemas-td">
            {
                schemas.map((description) => <span>{description}</span>)
            }
        </div>
    );
};

PsDocumentSchemasTd.propTypes = {
    schemas: PropTypes.array,
};

PsDocumentSchemasTd.defaultProps = {
    schemas: [],
};



// WEBPACK FOOTER //
// ./src/app/shared/components/document-schemas-td/PsDocumentSchemasTd.jsx